import React, { useContext } from 'react';

import { media } from 'context';
import { Grid, Layout, Link } from 'ds';
import {
  OFFICE_SEO_FOOTER_SERVICE_KEYS,
  OFFICE_SEO_SITEMAP_NYC_NEIGHBORHOODS,
  OFFICE_SEO_SITEMAP_SERVICE_LABEL,
  OFFICE_SEO_SITEMAP_SF_NEIGHBORHOODS,
  officeSeoPath,
  officeSeoPathCity,
  officeSeoPathHub
} from 'ux/Public/OfficeSeo/data/registry';
import type { NeighborhoodOfficeSeoData, OfficeSeoServiceKey } from 'ux/Public/OfficeSeo/data/types';

const OFFICE_SEO_FOOTER_MARKETS: Array<{
  marketSuffix: string;
  cityHubSlug: string;
  neighborhoods: NeighborhoodOfficeSeoData[];
}> = [
  { marketSuffix: 'NEW YORK CITY', cityHubSlug: 'new-york-city', neighborhoods: OFFICE_SEO_SITEMAP_NYC_NEIGHBORHOODS },
  {
    marketSuffix: 'SAN FRANCISCO BAY AREA',
    cityHubSlug: 'san-francisco',
    neighborhoods: OFFICE_SEO_SITEMAP_SF_NEIGHBORHOODS
  }
];

function OfficeSeoFooterServiceSubsection({
  serviceKey,
  neighborhoods,
  isFirst
}: {
  serviceKey: OfficeSeoServiceKey;
  neighborhoods: NeighborhoodOfficeSeoData[];
  isFirst: boolean;
}) {
  const { xs, sm, md } = useContext(media);
  const serviceLabel = OFFICE_SEO_SITEMAP_SERVICE_LABEL[serviceKey];
  const cityPathSegment = neighborhoods[0].cityPathSegment;

  return (
    <Layout marginTop={isFirst ? 0 : 28} width="100%" direction="column">
      <Link href={officeSeoPathCity(cityPathSegment, serviceKey)} color="white" size="body3" bold semibold={false}>
        {serviceLabel}
      </Link>
      <Layout marginTop={20}>
        <Grid itemsPerRow={xs ? 2 : sm || md ? 3 : 6} gapY={20}>
          {neighborhoods.map(n => (
            <Layout key={`${n.cityPathSegment}-${n.neighborhoodSlug}-${serviceKey}`}>
              <Link
                href={officeSeoPath(n.cityPathSegment, n.neighborhoodSlug, serviceKey)}
                color="white"
                size="body3"
                semibold={false}
              >
                {n.neighborhoodDisplayName}
              </Link>
            </Layout>
          ))}
        </Grid>
      </Layout>
    </Layout>
  );
}

function OfficeSeoFooterMarketSection({
  marketSuffix,
  cityHubSlug,
  neighborhoods
}: {
  marketSuffix: string;
  cityHubSlug: string;
  neighborhoods: NeighborhoodOfficeSeoData[];
}) {
  const marketTitle = `OFFICE SERVICES IN ${marketSuffix}`;

  return (
    <Layout width="100%" direction="column" paddingY={44}>
      <Link href={officeSeoPathHub(cityHubSlug)} color="white" size="body3" bold semibold={false}>
        {marketTitle}
      </Link>
      <Layout marginTop={20} direction="column" width="100%">
        {OFFICE_SEO_FOOTER_SERVICE_KEYS.map((serviceKey, index) => (
          <OfficeSeoFooterServiceSubsection
            key={serviceKey}
            serviceKey={serviceKey}
            neighborhoods={neighborhoods}
            isFirst={index === 0}
          />
        ))}
      </Layout>
    </Layout>
  );
}

export function OfficeSeoFooterSections() {
  return (
    <>
      {OFFICE_SEO_FOOTER_MARKETS.map(({ marketSuffix, cityHubSlug, neighborhoods }) => (
        <OfficeSeoFooterMarketSection
          key={neighborhoods[0].cityPathSegment}
          marketSuffix={marketSuffix}
          cityHubSlug={cityHubSlug}
          neighborhoods={neighborhoods}
        />
      ))}
    </>
  );
}
